import React from 'react'

const StockMovementReport = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Stock Movement Report</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Reports</li>
            <li className="breadcrumb-item active">Stock Movement Report</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Stock Movement Report</h5>
                <p>Stock movement report content will be displayed here.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default StockMovementReport

